import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { exportTableToPDF } from "./utils/exportPDF";


const Stock = () => {
  const [users, setUsers] = useState([]);
  const [kitchenId, setKitchenId] = useState(null);
  const [quantityFilter, setQuantityFilter] = useState("");
  ////
  const [showSwitchModal, setShowSwitchModal] = useState(false);
  const [selectedItemForSwitch, setSelectedItemForSwitch] = useState(null);
  const [availableQty, setAvailableQty] = useState("");

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const [searchTerm, setSearchTerm] = useState("");


  const getQuantityColor = (qty, min, max) => {
    const median = (min + max) / 2;

    if (qty <= min) return "red";

    if (qty > min && qty < median) return "orange";
    if (qty >= median && qty < max) return "orange";
    if (qty >= max) return "green";

    return "black";
  };

  const filteredUsers = users.filter((user) => {
    const itemNameMatch = user.itemName
      .toLowerCase()
      .includes(searchTerm.toLowerCase());

    const qty = parseFloat(user.quantity);
    const min = parseFloat(user.min_range);
    const max = parseFloat(user.max_range);
    const color = getQuantityColor(qty, min, max);

    let quantityMatch = true;
    if (quantityFilter === "red") quantityMatch = color === "red";
    else if (quantityFilter === "orange") quantityMatch = color === "orange";
    else if (quantityFilter === "green") quantityMatch = color === "green";

    return itemNameMatch && quantityMatch;
  }).sort((a, b) => (a.item_code || '').localeCompare(b.item_code || ''));

  const paginatedUsers = filteredUsers.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const totalPages = Math.ceil(filteredUsers.length / itemsPerPage);

  const handleSearch = (e) => {
    e.preventDefault();
    setCurrentPage(1); // Reset to first page after search
  };

  const handleReset = () => {
    setSearchTerm("");
    setCurrentPage(1);
  };


  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user"));
    if (user?.kitchen) {
      setKitchenId(user.kitchen);
      getDataList(user.kitchen);
      getDataList(user.kitchen);
    }
  }, []);

  useEffect(() => {
    setCurrentPage(1);
  }, [quantityFilter]);

  const getDataList = (kitchenId) => {
    axios
      .get(
        `https://ims-backend.indevconsultancy.in/api/kitchen-stock-reports/by-kitchen/${kitchenId}/`
      )
      .then((res) => {
        const formatted = res.data.map((item) => ({
          id: item.kitchenstock_id,
          itemName: item.stock_name,
          quantity: item.quantity,
          unit: item.unit,
          min_range: item.min_range,
          max_range: item.max_range,
          item_id: item.item_id,
          price: item.price,
          item_code: item.stock_code,
        }));
        setUsers(formatted);
      })
      .catch((err) => {
        console.error("Error fetching kitchen stock:", err);
      });
  };


  const [maxValue, setMaxValue] = useState("");
  const [minValue, setMinValue] = useState("");
  const [itemId, setitemid] = useState("");
  const [quantity_old, setiQuantityOld] = useState("");
  const [itemNamee, setitemName] = useState("");
  const [newQuantity, setnewQuantity] = useState("");
  const handleSubmit = async (e) => {
    e.preventDefault();
    const payload = {
      max_range: maxValue,
      min_range: minValue,
      item_id: itemId,
      kitchen_id: kitchenId,
      newQuantity: newQuantity,
      quantity_old: quantity_old,
    };

    try {
      const response = await fetch(
        "https://api-ims.indevconsultancy.in/stoct-update.php",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        }
      );

      if (response.ok) {
        const data = await response.json();
        console.log("Stock updated:", data);
        getDataList(kitchenId);
        setMaxValue("");
        setMinValue("");
        setMinValsetiQuantityOldue("");
        setiQuantityOld("");
        setitemName("");
        setitemid("");
        setnewQuantity("");

      } else {
        const errorText = await response.text();
        console.error("Failed to update stock:", errorText);
      }
    } catch (err) {
      console.error("Error:", err);
    }
  };

  const exportToCSV = () => {
    if (users.length === 0) return;

    const headers = [
      "S.No.",
      "Item",
      "Item Code",
      "Quantity",
      "Max Quantity",
      "Min Quantity",
    ];
    const rows = users.map((user, index) => [
      index + 1,
      `${user.itemName} (${user.unit})`, `${user.item_code}`,
      user.quantity,
      user.max_range,
      user.min_range,
    ]);

    const csvContent =
      "data:text/csv;charset=utf-8," +
      [headers, ...rows].map((e) => e.join(",")).join("\n");

    const encodedUri = encodeURI(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", "stock_list.csv");
    document.body.appendChild(link); // Required for Firefox
    link.click();
    document.body.removeChild(link); // Clean up
  };

  const exportToPDF = () => {
    if (users.length === 0) return alert("No data to export.");
    const headers = ["S.No.", "Item", "Item Code", "Quantity", "Max Quantity", "Min Quantity"];
    const rows = users.map((user, index) => [
      index + 1,
      `${user.itemName} (${user.unit})`,
      user.item_code,
      user.quantity,
      user.max_range,
      user.min_range,
    ]);
    exportTableToPDF({ title: "Stock List Report", headers, rows, filename: "stock_list.pdf", filterInfo: `Total: ${rows.length}` });
  };


  const [availableQty_2, setAvailableQty_2] = useState("");
  const [transferQty_2, setTransferQty_2] = useState("");
  const [subKitchens, setSubKitchens] = useState([]);
  const [selectedSubKitchen, setSelectedSubKitchen] = useState("");
  const [selectKitchenType, setSelectKitchenType] = useState("Sub_Kitchen");
  const [errors, setErrors] = useState({});

  // === Fetch Sub Kitchens on Modal Open ===
  useEffect(() => {
    if (showSwitchModal) {
      fetch(
        `https://api-ims.indevconsultancy.in/sub-kichange-get.php?kitchen_id=${kitchenId}`
      )
        .then((res) => res.json())
        .then((data) => {
          if (data.status === "success") {
            setSubKitchens(data.data);
          }
        })
        .catch((err) => console.error("Error fetching sub kitchens", err));
    }
  }, [showSwitchModal]);

  // === Submit Handler ===
  const handleSubmit_modal = () => {
    let newErrors = {};

    // Validation
    if (!availableQty || availableQty <= 0) {
      newErrors.availableQty = "Available quantity must be greater than 0";
    }
    if (!transferQty_2 || transferQty_2 <= 0) {
      newErrors.transferQty = "Please enter a valid transfer quantity";
    } else if (parseInt(transferQty_2) > parseInt(availableQty_2)) {
      newErrors.transferQty =
        "Transfer quantity cannot be greater than available quantity";
    }
    if (!selectedSubKitchen) {
      newErrors.subKitchen = "Please select a sub kitchen";
    }
    if (!selectKitchenType) {
      newErrors.KitchenType = "Please select a Kitchen Type";
    }

    setErrors(newErrors);
    if (Object.keys(newErrors).length > 0) return;

    // Payload for API
    const payload = {
      item_id: selectedItemForSwitch.item_id, // Ensure itemId exists in your object
      item_name: selectedItemForSwitch.itemName,
      KitchenType: selectKitchenType,
      available_qty: availableQty,
      kitchen_id: kitchenId,
      transfer_qty: transferQty_2,
      subkichen_id: selectedSubKitchen,
    };

    // API Call
    fetch("https://api-ims.indevconsultancy.in/sub-kichange-stoct-add.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status === "success") {
          alert("Stock switched successfully!");
          setShowSwitchModal(false);
          setAvailableQty_2("");
          setTransferQty_2("");
          setSelectedSubKitchen("");
          setSelectKitchenType("");
          setErrors({});
          getDataList(kitchenId);

        } else {
          alert("Failed: " + (data.message || "Unknown error"));
        }
      })
      .catch((err) => {
        console.error("API Error:", err);
        alert("Something went wrong!");
      });
  };

  return (
    <div className="container-fluid px-2">
      <div className="content">
        <div className="row align-items-center justify-content-between py-2">
          <div className="col-md-6 col-6">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb justify-content-start mb-0">
                <li className="breadcrumb-item">
                  <Link to="/mobilehome">Home</Link>
                </li>
              </ol>
            </nav>
          </div>
          <div className="col-md-6 col-6 text-end">
            <span className="fs-1">Stock List</span>
          </div>
        </div>


        <div className="card">
          <div className="card-header border-info">
            <form onSubmit={handleSearch}>
              <div className="row g-3">
                <div className="col-lg">
                  <input
                    type="text"
                    placeholder="Search"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    className="form-control"
                  />
                </div>
                <div className="col-lg-2">
                  <button type="submit" className="btn btn-primary w-100">
                    Search
                  </button>
                </div>
                <div className="col-lg-1">
                  <button
                    type="button"
                    onClick={handleReset}
                    className="btn btn-outline-dark w-100"
                  >
                    Reset
                  </button>
                </div>
              </div>
            </form>
          </div>
          <div className="card-body">
            <div className="d-flex justify-content-between align-items-center mb-2 flex-wrap">


              <div className="d-flex flex-wrap align-items-center gap-3 mt-2">
                <button
                  className="btn btn-sm"
                  style={{ color: "red" }}
                  onClick={() => setQuantityFilter("red")}
                >
                  ● Below Min
                </button>
                <button
                  className="btn btn-sm"
                  style={{ color: "orange" }}
                  onClick={() => setQuantityFilter("orange")}
                >
                  ● Between Min & Median / Max
                </button>
                <button
                  className="btn btn-sm"
                  style={{ color: "green" }}
                  onClick={() => setQuantityFilter("green")}
                >
                  ● Above Max
                </button>
                <button
                  className="btn btn-outline-dark btn-sm"
                  onClick={() => setQuantityFilter("")}
                >
                  Clear Filter
                </button>
              </div>

              <div className="text-end">
                <button className="btn btn-primary btn-sm me-1" onClick={exportToCSV}>
                  <i className="fas fa-file-csv me-1"></i>Export CSV
                </button>
                <button className="btn btn-danger btn-sm" onClick={exportToPDF}>
                  <i className="fas fa-file-pdf me-1"></i>Export PDF
                </button>
              </div>
            </div>

            <div className="table-responsive scrollbar">
              <table className="table text-center table-bordered table-striped fs--1 mb-0">
                <thead className="bg-primary text-white">
                  <tr>
                    <th>S.No.</th>
                    <th>Item</th>
                    <th>Item Code</th>
                    <th>Quantity</th>
                    <th>Price</th>
                    <th>Max Quantity</th>
                    <th>Min Quantity</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {paginatedUsers.length === 0 ? (
                    <tr>
                      <td colSpan="7">Loading or no data available</td>
                    </tr>
                  ) : (
                    paginatedUsers.map((user, i) => (
                      <tr key={i}>
                        <td>{(currentPage - 1) * itemsPerPage + i + 1}</td>
                        <td>
                          {user.itemName} ({user.unit})
                        </td>
                        <td>{user.item_code}</td>
                        <td
                          style={{
                            color: getQuantityColor(
                              parseFloat(user.quantity),
                              parseFloat(user.min_range),
                              parseFloat(user.max_range)
                            ),
                          }}
                        >
                          {parseFloat(user.quantity).toFixed(2)}
                        </td>
                        <td>{user.price}</td>
                        <td>{user.max_range}</td>
                        <td>{user.min_range}</td>
                        <td>
                          <div className="d-flex gap-2 justify-content-center flex-wrap">
                            {/* <button
                              className="btn btn-success btn-sm"
                              type="button"
                              data-bs-toggle="modal"
                              data-bs-target="#editModal"
                              onClick={() => {
                                setMinValue(user.min_range);
                                setMaxValue(user.max_range);
                                setitemid(user.item_id);
                                setiQuantityOld(user.quantity);
                                setitemName(user.itemName);
                                setnewQuantity(user.quantity);
                              }}
                            >
                              <i className="fas fa-edit"></i>
                            </button> */}

                            <button
                              className="btn btn-warning btn-sm"
                              type="button"
                              onClick={() => {
                                setSelectedItemForSwitch(user);
                                setAvailableQty(user.quantity);
                                setShowSwitchModal(true);
                              }}
                            >
                              Switch Stock
                            </button>
                          </div>
                        </td>


                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>

            <div className="d-flex justify-content-between align-items-center mt-3">
              <button
                className="btn btn-outline-primary btn-sm"
                onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                disabled={currentPage === 1}
              >
                Previous
              </button>
              <span>
                Page {currentPage} of {totalPages}
              </span>
              <button
                className="btn btn-outline-primary btn-sm"
                onClick={() =>
                  setCurrentPage((prev) => Math.min(prev + 1, totalPages))
                }
                disabled={currentPage === totalPages}
              >
                Next
              </button>
            </div>
          </div>
        </div>
      </div>



      {/* Modal for Editing Stock Range */}
      <div className="modal fade" id="editModal" tabIndex="-1" aria-labelledby="editModalLabel" aria-hidden="true" >

        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <form onSubmit={handleSubmit}>
              <div className="modal-header">
                <h5 className="modal-title" id="editModalLabel">
                  Edit Stock Range
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body">
                <div className="row">
                  <div className="col-md-6 mb-3">
                    <label htmlFor="">items Name</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter items Name"
                      value={itemNamee} readOnly
                      onChange={(e) => setitemName(e.target.value)}
                    />
                  </div>
                  <div className="col-md-6 mb-3">
                    <label htmlFor="">Available Quantity</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter Available Quantity"
                      value={quantity_old} disabled
                      onChange={(e) => quantity_old(e.target.value)}
                    />
                  </div>
                  <div className="col-md-12 mb-3">
                    <label htmlFor="">Update Quantity</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter Update Quantity"
                      value={newQuantity}
                      onChange={(e) => setnewQuantity(e.target.value)}
                    />
                  </div>
                  <div className="col-md-6 mb-3">
                    <label htmlFor="">Max Value</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter Max Value"
                      value={maxValue}
                      onChange={(e) => setMaxValue(e.target.value)}
                    />
                  </div>
                  <div className="col-md-6 mb-3">
                    <label htmlFor="">Min Value</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter Min Value"
                      value={minValue}
                      onChange={(e) => setMinValue(e.target.value)}
                    />
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-bs-dismiss="modal"
                >
                  Close
                </button>
                <button
                  type="submit"
                  className="btn btn-primary"
                  data-bs-dismiss="modal"
                >
                  Submit
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

      {/* Modal for Switching Stock */}
      {showSwitchModal && (
        <div
          className="modal fade show"
          style={{ display: "block", background: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog modal-md">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Switch Stock</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowSwitchModal(false)}
                ></button>
              </div>
              <div className="modal-body">
                {selectedItemForSwitch && (
                  <>
                    {/* Select Sub Kitchen */}
                    <div className="mb-3">
                      <label className="form-label">Kitchen Type</label>
                      <select
                        className={`form-control ${errors.KitchenType ? "is-invalid" : ""}`}
                        value={selectKitchenType}
                        onChange={(e) => setSelectKitchenType(e.target.value)}
                      >
                        <option value="">Kitchen Type</option>
                        <option value="Sub_Kitchen" > Sub Kitchen </option>
                        <option value="Bandara">Bandara</option>

                      </select>
                      {errors.KitchenType && (
                        <div className="invalid-feedback">{errors.KitchenType}</div>
                      )}
                    </div>
                    {/* Item Name */}
                    <div className="mb-3">
                      <label className="form-label">Item Name</label>
                      <input
                        type="text"
                        className="form-control"
                        value={selectedItemForSwitch.itemName}
                        readOnly
                      />
                    </div>

                    {/* Available Qty */}
                    <div className="mb-3">
                      <label className="form-label">Available Quantity</label>
                      <input
                        readOnly
                        type="number"
                        className={`form-control ${errors.availableQty ? "is-invalid" : ""}`}
                        value={availableQty}
                        onChange={(e) => setAvailableQty(e.target.value)}
                      />
                      {errors.availableQty && (
                        <div className="invalid-feedback">{errors.availableQty}</div>
                      )}
                    </div>

                    {/* Transfer Qty */}
                    <div className="mb-3">
                      <label className="form-label">Transfer Quantity</label>
                      <input
                        type="number"
                        className={`form-control ${errors.transferQty ? "is-invalid" : ""}`}
                        placeholder="Enter Transfer Quantity"
                        value={transferQty_2}
                        max={availableQty} // prevent typing more than available
                        onChange={(e) => {
                          const value = e.target.value;
                          if (parseInt(value) > parseInt(availableQty)) {
                            setTransferQty_2(availableQty); // auto-correct
                          } else {
                            setTransferQty_2(value);
                          }
                        }}
                      />
                      {errors.transferQty && (
                        <div className="invalid-feedback">{errors.transferQty}</div>
                      )}
                    </div>

                    {/* Select Sub Kitchen */}
                    <div className="mb-3">
                      <label className="form-label">Select Sub Kitchen</label>
                      <select
                        className={`form-control ${errors.subKitchen ? "is-invalid" : ""}`}
                        value={selectedSubKitchen}
                        onChange={(e) => setSelectedSubKitchen(e.target.value)}
                      >
                        <option value="">-- Select Sub Kitchen --</option>

                        {/* When Sub_Kitchen selected → show all except Bandara */}
                        {selectKitchenType === "Sub_Kitchen" &&
                          subKitchens
                            .filter(sub => sub.subKitchen_name !== "Bandara")
                            .map(sub => (
                              <option key={sub.subkichen_id} value={sub.subkichen_id}>
                                {sub.subKitchen_name}
                              </option>
                            ))}

                        {/* When Bandara selected → show ONLY Bandara */}
                        {selectKitchenType === "Bandara" &&
                          subKitchens
                            .filter(sub => sub.subKitchen_name === "Bandara")
                            .map(sub => (
                              <option key={sub.subkichen_id} value={sub.subkichen_id}>
                                {sub.subKitchen_name}
                              </option>
                            ))}
                      </select>


                      {errors.subKitchen && (
                        <div className="invalid-feedback">{errors.subKitchen}</div>
                      )}
                    </div>
                  </>
                )}
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => setShowSwitchModal(false)}
                >
                  Close
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={handleSubmit_modal}
                >
                  Submit
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>


  );
};

export default Stock;
